import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import Player from "components/player";
import FormConfirm from "components/form/form-confirm";

const LiveEmissionPage = ({ event, intl }) => {
  if (!event || !event.infoBert || !event.infoBert.liveViewUrl) {
    return (
      <FormConfirm warning show hideCloseButton label={intl.formatMessage({ id: "event.liveEmision.noViewer" })} />
    );
  }

  return <Player fileUrl={event.infoBert.liveViewUrl} />;
};

LiveEmissionPage.propTypes = {
  /**
   * Evento para el que se muestra la página de emisión en directo
   */
  event: PropTypes.object,
};

export default injectIntl(LiveEmissionPage);
